import { useQuery } from '@apollo/client';
import { GET_DASHBOARD } from '../services/graphql';
import keycloak from '../keycloak';


const useDashboardQuery = () => {

    const email = keycloak.tokenParsed?.email; // use Keycloak token email

    const { loading, data, refetch } = useQuery(GET_DASHBOARD, {
        variables: { email },
        skip: !email, // skip query until email is available
    });

    return {loading, data, refetch};

};

export default useDashboardQuery;
